// extracted by mini-css-extract-plugin
export default {"avatar":"V8gwZj","withBorder":"CiSb4N","avatarPlaceholder":"aBATL4","memberInitials":"ZeCqr2","loggedOut":"b2cSkJ"};